import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'

import { RECENT_SEARCH_TOKEN } from '../../utils/constants'

export const getPlaceholderText = (selectedSearchObject: SearchObjectType): string => {
  let result = 'Search accounts, people, devices, orders'

  if (selectedSearchObject === 'Accounts') {
    result = 'Search accounts'
  } else if (selectedSearchObject === 'Devices') {
    result = 'Search devices'
  } else if (selectedSearchObject === 'People') {
    result = 'Search people'
  } else if (selectedSearchObject === 'Orders') {
    result = 'Search orders'
  }

  return result
}

export const getRecents = () => {
  let recents: RecentSearchItem[]

  try {
    recents = JSON.parse(localStorage.getItem(RECENT_SEARCH_TOKEN) ?? '[]')
  } catch {
    recents = []
  }

  return recents
}

export const addToRecent = (entity: RecentSearchItem) => {
  const recents = getRecents()

  const entityExistsIndex = recents.findIndex(
    (item) => item.entityType === entity.entityType && (item.id == null ? item.searchQuery === entity.searchQuery : item.id === entity.id)
  )
  if (entityExistsIndex >= 0) {
    // remove the item from the list so we can push it to the top later
    recents.splice(entityExistsIndex, 1)
  }

  // add the item to the front of the list
  recents.unshift(entity)

  // if the list is bigger than 5, truncate it
  if (recents.length > 5) {
    recents.length = 5
  }

  localStorage.setItem(RECENT_SEARCH_TOKEN, JSON.stringify(recents))
  return recents
}

export const getSuggestionHighlights = (primaryText: string, secondaryText: string[], searchValue: string) => {
  const primaryMatches = match(primaryText, searchValue, { insideWords: true })
  const primaryParts = parse(primaryText, primaryMatches)
  const primaryHasMatch = primaryParts.find((part) => part.highlight)

  const secondary = secondaryText.map((text) => {
    const secondaryMatches = match(text, searchValue, { insideWords: true })
    const secondaryParts = parse(text, secondaryMatches)
    const secondaryHasMatch = !!secondaryParts.find((part) => part.highlight)
    return { secondaryParts, secondaryHasMatch }
  })

  return { primary: primaryParts, primaryHasMatch, secondary }
}
